import React from 'react'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import {toast} from 'react-toastify';
import ToastMessage from '../components/common/toast-message'
import {check} from '../utils/tokenUtils';
import {GET_PRIVACY_POLICY_FULFILLED, GET_PRIVACY_POLICY_PENDING} from "../reducers/privacyPolicyReducer";

export const saveTextContent = (url, body) => (dispatch) => {
  dispatch({
    type: "SAVE_TEXT_CONTENT_PENDING",
    payLoad: ''
  });

  const data = {
    content: {
      content_type: 'text',
      body: body
    }
  };

  return irelandApi.patch(`/api/admin/contents/${url}`, data)
    .then((response) => {
      dispatch({
        type: "SAVE_TEXT_CONTENT_FULFILLED",
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Content saved successfully"/>);
    })
    .catch((error) => {
      dispatch({
        type: 'SAVE_TEXT_CONTENT_REJECTED',
        payLoad: error.data
      })
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
    })
};

export const saveVideoContent = (url, body) => (dispatch) => {
  dispatch({
    type: "SAVE_VIDEO_CONTENT_PENDING",
    payLoad: ''
  });

  const data = {
    content: {
      content_type: 'video',
      body: body
    }
  };

  return irelandApi.patch(`/api/admin/contents/${url}`, data)
    .then((response) => {
      dispatch({
        type: "SAVE_VIDEO_CONTENT_FULFILLED",
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Video saved successfully"/>);
    })
    .catch((error) => {
      dispatch({
        type: 'SAVE_VIDEO_CONTENT_REJECTED',
        payLoad: error.data
      })
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save video"/>);
    })
};

export const saveImageContent = (url, image) => (dispatch) => {
  dispatch({
    type: "SAVE_IMAGE_CONTENT_PENDING",
    payLoad: ''
  });

  let formData = new FormData();
  formData.append("content[content_type]", "image");
  formData.append("content[image]", image);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  return irelandApi.patch(`/api/admin/contents/${url}`, formData, config)
    .then((response) => {
      dispatch({
        type: "SAVE_IMAGE_CONTENT_FULFILLED",
        payLoad: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Image saved successfully"/>);
    })
    .catch((error) => {
      dispatch({
        type: 'SAVE_IMAGE_CONTENT_REJECTED',
        payLoad: error.data
      });
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save image"/>);
    })
};

export const getPrivacyPolicy = () => (dispatch) => {
  dispatch({type: GET_PRIVACY_POLICY_PENDING});
  return irelandApi.get('api/pages/privacy-policy')
    .then((response) => {
      dispatch({
        type: GET_PRIVACY_POLICY_FULFILLED,
        payLoad: response.data.meta.contents[0].body
      });
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during load privacy policy content"/>);
    })
};


export const loadPageContent = (url) => (dispatch) => {
  dispatch({
    type: "GET_PAGE_CONTENT_PENDING",
    payLoad: ''
  });
  return irelandApi.get(url)
    .then((response) => {
      if (!response.data.data.attributes['login-required'] ||
        check()) {
        dispatch({
          type: "GET_PAGE_CONTENT_FULFILLED",
          payLoad: response.data
        });
      } else {
        toast.error(<ToastMessage iconStyle="error"
                                  message="You must log in to view this page"/>);
        history.push('/login');
      }
    })
};


// WEBPACK FOOTER //
// ./src/actions/content.js